export const getRedirectURL = _ => {
  return (
    process.env.REACT_APP_LOGIN_REDIRECT_URL +
    encodeURIComponent(window.location.origin)
  );
};
